module.exports = __webpack_public_path__ + "static/media/img2-2.0e4e1d87.png";